import { computed } from 'vue';
import { useQuery } from '@tanstack/vue-query';

import { queryKeys } from '@/queries/_shared/queryKeys';
import { feedEndpoints, socialClient, unwrapBody } from '@/queries/feed/client';

function normalizeItems(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
}

async function fetchNewsList(params) {
  const response = await socialClient.get(feedEndpoints.newsList, { params });
  return normalizeItems(unwrapBody(response.data));
}

async function fetchNewsDetail(id) {
  const response = await socialClient.get(`${feedEndpoints.newsList}/${id}`);
  return unwrapBody(response.data);
}

export function useFeedNewsListQuery(paramsRef) {
  const params = computed(() => paramsRef?.value || {});
  return useQuery({
    queryKey: computed(() => queryKeys.feed.newsList(params.value)),
    queryFn: () => fetchNewsList(params.value)
  });
}

export function useFeedNewsDetailQuery(idRef) {
  const id = computed(() => idRef?.value);
  return useQuery({
    queryKey: computed(() => queryKeys.feed.newsDetail(id.value)),
    queryFn: () => fetchNewsDetail(id.value),
    enabled: computed(() => Boolean(id.value))
  });
}
